export class GridDataAdapter {
    static processorsMap = {
        object: (data, field) => {
            if (field.outputField) {
                return data?.[field.object]?.[field.outputField] || null;
            }
            if (field.fullObject) {
                return data?.[field.object] || null;
            }
            return data?.[field.object]?.id || null;
        },
        array: (data, field) => {
            const raw = data?.[field.array];
            return Array.isArray(raw) ? raw.map((item) => item.id) : [];
        },
        boolean: (data, field) => data?.[field.id] ?? false,
        number: (data, field) => data?.[field.id] ?? 0,
        default: (data, field) => data?.[field.id] ?? null
    };

    static transform(data, fields) {
        const transformedData = {};

        if (data?.id) {
            transformedData.id = data.id;
        }

        fields
            .filter((f) => !f.hideOnAdd)
            .forEach((field) => {
                let processorKey = 'default';
                const processor = this.processorsMap[field.type] || (
                    field.object ? this.processorsMap[ 'object'] : this.processorsMap[processorKey]
                );
                transformedData[field.id] = processor(data, field);
            });
        return transformedData;
    }
}
